module.exports = __webpack_public_path__ + "static/media/email.6f10e475.svg";